export const focusedViewFilterTextWithUnseenCount = "IRSFe";
export const otherViewFilterTextWithUnseenCount = "Z87ZRe";
export default {focusedViewFilterTextWithUnseenCount,otherViewFilterTextWithUnseenCount};